export class AlertDialogData {
  public confirmationText: string;
  public dialogTitle: string;
  public actionText?: string;
  public actionIcon?: string;
  public htmlText?: boolean;
}